import { useCallback, useState } from "react";

const INITIAL = { more: false, report: false, block: false, leave: false };

export function useModals(initial = INITIAL) {
  const [modals, setModals] = useState(initial ?? INITIAL);
  const open = useCallback((key) => {
    setModals((prev) => ({ ...prev, [key]: true }));
  }, []);
  const close = useCallback((key) => {
    setModals((prev) => ({ ...prev, [key]: false }));
  }, []);
  const closeAll = useCallback(() => setModals(INITIAL), []);
  return [modals, setModals, { open, close, closeAll }];
}
